// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__3JIQc","clickable":"Icon_clickable__lubv8"};